import { Controller } from "@hotwired/stimulus";

const SLIDE_MS = 200;

// A slide-over that a turbo frame delivers already in the document, so the panel has
// to be painted off-screen once before the class that moves it on-screen is removed.
// Dropping it straight into its open position skips the transition entirely.
//
// Every save, status change, and step into the edit form replaces the frame's contents,
// which mounts a second controller over an already-open panel. Only the first mount
// slides, tracked on the frame itself because that element survives the swap. Without
// it the panel appears to shut and reopen on every action. Connecting happens before
// paint, so the later mounts can drop the class outright and never animate.
//
// Closing empties the frame rather than hiding the panel, so the next protocol always
// fetches fresh markup instead of reopening whatever was last rendered.
export default class extends Controller {
  static targets = ["panel"];

  connect() {
    this.closeOnEscape = (event) => {
      if (event.key === "Escape") this.close();
    };

    document.addEventListener("keydown", this.closeOnEscape);
    document.body.classList.add("overflow-hidden");

    if (this.frame.dataset.drawerOpen === "true") {
      this.panelTarget.classList.remove("translate-x-full");
    } else {
      this.frame.dataset.drawerOpen = "true";
      requestAnimationFrame(() => this.panelTarget.classList.remove("translate-x-full"));
    }
  }

  disconnect() {
    document.removeEventListener("keydown", this.closeOnEscape);
    document.body.classList.remove("overflow-hidden");
  }

  close() {
    const frame = this.frame;

    frame.dataset.drawerOpen = "false";
    this.panelTarget.classList.add("translate-x-full");
    setTimeout(() => {
      frame.innerHTML = "";
    }, SLIDE_MS);
  }

  get frame() {
    return this.element.closest("turbo-frame");
  }
}
